import { SET_VERONICA_DATA } from './actions';

const initialState = {
  data: null
};

const veronicaReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VERONICA_DATA:
      return {
        ...state,
        data: action.payload
      };
    default:
      return state;
  }
};

export default veronicaReducer;
